import { themeObject } from 'lib';

export const undefinedAttributeOptions = ['REMOVE', 'KEEP', 'ERROR'];

export const dictionaryManagerDetailStyles = {
    divider: {
        my: 2.5,
        weight: '1px',
        borderColor: themeObject.palette.grayScale[200],
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        mt: 2,
    },
    propertiesFieldGroup: {
        display: 'flex',
        flexDirection: 'column',
    },
    containerStyles: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        backgroundColor: themeObject.palette.background.default,
        p: '10.47px 31px 47.53px 31px',
        borderRadius: '5px',
    },
    nodeColorWrapper: {
        mt: '19.69px',
    },
    nodeColorLabelStyles: {
        ...themeObject.typography.inputLabel,
        color: themeObject.palette.grayScale[700],
        lineHeight: '21.17px',
        letterSpacing: '0.15px',
    },
};

export const colorDataDictionary = [
    {
        id: 1,
        variableName: 'burst-iq-tertiary-red-300',
        colorCode: '#FB5E62',
        checked: false,
    },
    {
        id: 2,
        variableName: 'burst-iq-secondary-300',
        colorCode: '#F58838',
        checked: false,
    },
    {
        id: 3,
        variableName: 'burst-iq-tertiary-yellow-500',
        colorCode: '#FFD02B',
        checked: false,
    },
    {
        id: 4,
        variableName: 'burst-iq-tertiary-green-300',
        colorCode: '#52D9AE',
        checked: false,
    },
    {
        id: 5,
        variableName: 'burst-iq-tertiary-cyan-400',
        colorCode: '#26C6DA',
        checked: false,
    },
    {
        id: 6,
        variableName: 'burst-iq-tertiary-blue-400',
        colorCode: '#3B9CF5',
        checked: false,
    },
    {
        id: 7,
        variableName: 'burst-iq-tertiary-deep-purple-400',
        colorCode: '#8C5ED6',
        checked: false,
    },
    {
        id: 8,
        variableName: 'burst-iq-tertiary-mauve-400',
        colorCode: '#C454A1',
        checked: false,
    },
];
